<template>
  <el-row
    v-if="getProjects.length > 0"
    style="display: flex"
    class="list_content"
  >
    <template v-if="!background_images">
      <template v-if="background_image_url_state">
        <img class="bg_image" :src="background_image_url_state" />
      </template>
      <template v-else>
        <img
          class="bg_image"
          :src="require('@/assets/static/images/bg/' + background_image)"
        />
      </template>
      <div
        class="background_image_overlay"
        style="
          background-color: #dee8f2;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.5;
        "
      ></div>
    </template>
    <div
      v-else
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      :style="'background-color: ' + background_images"
    ></div>
    <el-col
      :span="left_col"
      :style="taskPanelOpen ? openListStyle : closedListStyle"
    >
      <div class="project_body vertical_scrollbar" :data-col-span="left_col">
        <div class="project_title">
          <RenameElement
            :id="project_id"
            :name="project_name"
            :type="'project'"
            v-if="$route.matched[0].name != 'Inbox'"
          />
          <h3 v-else>{{ $t("app.shortcuts.inbox") }}</h3>
          <ProjectSetting
            :key="project_id"
            :project_id="project_id"
            :project_name="project_name"
          />
          <!-- <el-popover
                        placement="bottom-end"
                        width="50"
                        trigger="click"
                        class="project_popover"
                    >
                        <ProjectSetting
                        :project_id="project_id"
                        :project_name="project_name"
                        />
                        <i
                        slot="reference"
                        class="el-icon-more-outline project_more_icon"
                        ></i>
                    </el-popover> -->
        </div>
        <Tasks :project_id="project_id" :project_name="project_name" />
      </div>
    </el-col>

    <router-view></router-view>
    <!-- <ChatOtherAction /> -->
  </el-row>
  <p v-else></p>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Tasks from "@/components/tasks/Tasks";
import ProjectSetting from "@/components/projects/ProjectSetting";
import RenameElement from "@/components/app/RenameElement";
import File from "../utils/aws";
// import ChatOtherAction from "@/components/comments/ChatOtherAction";

export default {
  name: "Project",
  data() {
    return {
      project_name: "",
      project_id: "",
      project_sections: [],
      tasks: [],
      left_col: 24,
      background_image_url: "",
    };
  },
  mounted() {
    if (this.$route.params.task_id) {
      this.math_cols(true);
      this.set_active_task_window(this.$route.params.task_id);
    } else {
      this.set_active_task_window("");
    }
    this.renderTitle(this.getProjects, this.$route.params.project_id);
    this.socket_send_project_id(this.$route.params.project_id);
    window.addEventListener("blur", () => {
      this.set_active_task_window("");
    });
    window.addEventListener("focus", () => {
      if (this.$route.params.task_id) {
        this.set_active_task_window(this.$route.params.task_id);
        this.changeCommentLoading();
      }
    });
  },
  methods: {
    ...mapActions(["socket_send_project_id", "socket_add_comment"]),
    ...mapMutations([
      "set_active_task_window",
      "changeCommentLoading",
      "backgroundImageUrl",
    ]),
    async backgroundImageRender() {
      this.background_image_url = "";
      if (
        !this.background_images.some(
          (e) => e.image_name == this.getUserData.background_image
        )
      ) {
        if (
          localStorage.getItem(
            "background_image_" + this.getUserData.background_image
          )
        ) {
          this.background_image_url = localStorage.getItem(
            "background_image_" + this.getUserData.background_image
          );
          this.backgroundImageUrl(this.background_image_url);
        } else {
          const aws = new File();
          this.background_image_url = await aws.read(
            `Users/${this.getUserData._id}/background_image/${this.getUserData.background_image}`
          );
          this.backgroundImageUrl(this.background_image_url);
          this.toDataUrl(this.background_image_url, (myBase64) => {
            localStorage.removeItem(
              "background_image_" + this.getUserData.background_image
            );
            localStorage.setItem(
              "background_image_" + this.getUserData.background_image,
              myBase64
            );
          });
        }
      } else {
        this.backgroundImageUrl(this.background_image_url);
      }
    },
    toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    async renderTitle(projects, route_id) {
      if (projects && projects.length > 0) {
        const project = projects
          .map((t) => ({ ...t }))
          .filter((t) => t._id == route_id)[0];
        if (project && project.name) {
          this.project_name = project.name;
          this.project_id = project._id;
        } else {
          this.$router.push("/404");
        }
      }
    },
    truncateStr() {
      const title = this.$refs.task_title;
      const parent = title.parentElement;
      const titleLength = title.innerHTML.length;
      const titleFontSize = +window
        .getComputedStyle(parent)
        .fontSize.match(/\d+/)[0];
      const titleWidth = title.clientWidth;
      const parentWidth = parent.clientWidth;
      const paddingLeft = +window
        .getComputedStyle(parent)
        .paddingLeft.match(/\d+/)[0];
      const paddingRight = +window
        .getComputedStyle(parent)
        .paddingRight.match(/\d+/)[0];
      // console.log(titleWidth, parentWidth - paddingLeft - paddingRight);

      if (titleWidth > parentWidth - paddingLeft - paddingRight) {
        title.innerHTML = title.innerHTML.substring(0, titleLength - 1);
        this.truncateStr();
      } else if (
        titleWidth + titleFontSize >
        parentWidth - paddingLeft - paddingRight
      ) {
        title.innerHTML = title.innerHTML.substring(0, titleLength - 3) + "...";
      }
    },
    math_cols(show) {
      if (show) {
        this.left_col = 16;
        if (innerWidth <= 540) {
          this.left_col = 24;
        } else if (innerWidth <= 768) {
          this.left_col = 14;
        }
      } else {
        this.left_col = 24;
      }
    },
  },
  computed: {
    ...mapGetters(["getProjects", "getTasks", "getUserData"]),
    background_image() {
      return this.$store.state.key.background_image;
    },
    background_images() {
      let image = this.$store.state.key.background_images.find(
        (e) => e.image_name == this.$store.state.key.background_image
      );
      if (image) {
        return image.color ? image.color : false;
      } else {
        return false;
      }
    },
    background_image_url_state() {
      return this.$store.state.key.background_image_url;
    },
    taskPanelOpen() {
      return Boolean(this.$route.params.task_id);
    },
    openListStyle() {
      return {
        width: "auto",
        maxWidth: "none",
        flex: "1 1 auto",
        minWidth: "420px",
        // иначе transition: all у .el-col-16 растягивает flex-grow и min-width,
        // и панель задачи выезжает из-под узкого списка слева
        transition: "none",
      };
    },
    // И без панели тоже: иначе у .el-col-24 при закрытии едут сразу flex-grow
    // и width, с разной скоростью, и список пружинит туда-обратно
    closedListStyle() {
      return { transition: "none" };
    },
  },
  watch: {
    getProjects(projects) {
      this.renderTitle(projects, this.$route.params.project_id);
    },
    $route(to) {
      if (
        to.name == "Project" ||
        to.name == "Inbox" ||
        to.name == "Project_shortcuts"
      ) {
        this.math_cols(false);
        this.renderTitle(this.getProjects, to.params.project_id);
        this.socket_send_project_id(this.$route.params.project_id);
        this.set_active_task_window("");
        // alert(0)
      } else if (
        to.name == "TaskBody" ||
        to.name == "InboxTaskBody" ||
        to.name == "TaskBody_shortcuts"
      ) {
        if (document.getElementById("add_comment")) {
          document.getElementById("add_comment").focus();
        }
        // this.math_cols(false);
        this.renderTitle(this.getProjects, to.params.project_id);
        this.socket_send_project_id(this.$route.params.project_id);
        // this.set_active_task_window("");
        // alert(1)
        this.math_cols(true);
        this.set_active_task_window(to.params.task_id);
      }
    },
  },
  components: {
    Tasks,
    ProjectSetting,
    RenameElement,
    // ChatOtherAction,
  },
};
</script>
